import React from 'react';
import { Button, ButtonGroup, ButtonToolbar } from 'rsuite'

const ButtonThree = ( {installment, onChange}) => {
    const setInstallment_1 = () => {
        onChange(1);
    }

    const setInstallment_2 = () => {
        onChange(2);
    }

    const setInstallment_4 = () => {
        onChange(4);
    }

    return(
      <ButtonToolbar>
        <ButtonGroup className="buttongroup-three">
            <Button className="child" active={installment === 1} onClick={setInstallment_1}>1 вноска</Button>
            <Button className="child" active={installment === 2} onClick={setInstallment_2}>2 вноски</Button>
            <Button className="child" active={installment === 4} onClick={setInstallment_4}>4 вноски</Button>
        </ButtonGroup>
      </ButtonToolbar> )
    }

export default ButtonThree;